import * as React from 'react'; // @ts-ignore

import { ThemeContext } from 'react-fela';
import { useStyles, getUnhandledProps } from '@fluentui/react-bindings';
export var svgIconClassName = 'ui-icon';
export var svgIconDisplayName = 'SvgIcon';
export var svgIconHandledProps = ['bordered', 'className', 'circular', 'design', 'disabled', 'outline', 'size', 'rotate', 'styles', 'variables', 'xSpacing'];

var createSvgIcon = function createSvgIcon(_ref) {
  var svg = _ref.svg,
      displayName = _ref.displayName,
      _ref$handledProps = _ref.handledProps,
      handledProps = _ref$handledProps === void 0 ? [] : _ref$handledProps;

  var Component = function Component(props) {
    var context = React.useContext(ThemeContext);
    var alt = props.alt,
        ariaLabel = props['aria-label'],
        bordered = props.bordered,
        circular = props.circular,
        className = props.className,
        design = props.design,
        disabled = props.disabled,
        outline = props.outline,
        _props$rotate = props.rotate,
        rotate = _props$rotate === void 0 ? 0 : _props$rotate,
        _props$size = props.size,
        size = _props$size === void 0 ? 'medium' : _props$size,
        styles = props.styles,
        variables = props.variables,
        xSpacing = props.xSpacing;

    var _useStyles = useStyles(svgIconDisplayName, {
      className: svgIconClassName,
      mapPropsToStyles: function mapPropsToStyles() {
        return {
          bordered: bordered,
          circular: circular,
          disabled: disabled,
          outline: outline,
          rotate: rotate,
          size: size,
          xSpacing: xSpacing
        };
      },
      mapPropsToInlineStyles: function mapPropsToInlineStyles() {
        return {
          className: className,
          design: design,
          styles: styles,
          variables: variables
        };
      },
      rtl: context.rtl
    }),
        classes = _useStyles.classes;

    var unhandledProps = getUnhandledProps([].concat(svgIconHandledProps, handledProps), props);
    return React.createElement('span', Object.assign({
      role: 'img',
      'aria-hidden': alt || ariaLabel ? undefined : 'true',
      'aria-label': ariaLabel,
      className: classes.root
    }, unhandledProps), svg({
      classes: classes,
      rtl: context.rtl,
      props: props
    }));
  };

  Component.displayName = displayName;
  Component.handledProps = [].concat(svgIconHandledProps, handledProps);
  return Component;
};

export default createSvgIcon;
//# sourceMappingURL=createSvgIcon.js.map
